module.exports = __webpack_public_path__ + "static/joystream-dao-background-6cb5a296b96036b71ceca5d141c41df0.webp";